import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { GetAcademicOverviewData } from 'domain/usecases';
export class RemoteGetAcademicOverviewData implements GetAcademicOverviewData {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<GetAcademicOverviewData.Result>,
  ) {}

  private generateUrl(params: Record<string, string | string[]>): string {
    const baseUrl = this.url;
    const queryParams: string[] = [];

    for (const [key, value] of Object.entries(params)) {
      if (value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          value.forEach((val) => {
            queryParams.push(`${key}=${val}`);
          });
        } else {
          queryParams.push(`${key}=${value}`);
        }
      }
    }

    if (queryParams.length === 0) {
      return baseUrl;
    }

    return `${baseUrl}?${queryParams.join('&')}`;
  }

  async execute(
    params: GetAcademicOverviewData.Params,
  ): Promise<GetAcademicOverviewData.Result> {
    const url = this.generateUrl({
      starts: params.starts,
      ends: params.ends,
      entity: params.entity,
      course: params.course,
      semester: params.semester,
      curricularUnit: params.curricularUnit,
      groups: params.groups,
    });

    // const arrayOfGroupsQueryParams =
    //   params.groups.length > 0
    //     ? params.groups
    //         .map((group) => `&groups=${group}`)
    //         .reduce((accumulator, currentValue) => accumulator + currentValue)
    //     : '';

    const httpResponse = await this.httpClient.request({
      method: 'get',
      url,
      // url: `${this.url}?starts=${params.starts}&ends=${params.ends}&entity=${params.entity}&course=${params.course}${arrayOfGroupsQueryParams}`,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body.message);
    }
  }
}
